import { AppEvents, useEventBus } from "@cs_teamwaydev/mailvista-sdk_react";

const useGetEventBus = <T extends AppEvents[keyof AppEvents]>(
    event: keyof AppEvents,
    callback: (data: T) => void,
) => {
    const eventBus = useEventBus(
        event,
        callback as (event: AppEvents[keyof AppEvents]) => void,
    );

    return {
        emit: eventBus.emit,
        on: eventBus.on,
        off: eventBus.off,
    };
};

export default useGetEventBus;
